import { addImageNotAvailable, buildApiImageUrl } from 'services/product-data.service';
import { DataResult } from 'models/data';
import { MetricsLoadingSpinner } from 'components/MetricsLoadingSpinner';
import { useContext } from 'react';
import { TenantConfigContext } from 'context/TenantConfigContext';
import { EntityHeader } from 'pages/entities/components/EntityHeader';
import { categoryLink } from 'pages/entities/entityhelper';
import { useParams } from 'react-router-dom';

interface ProductDetailsSummaryProps {
  response: DataResult | null;
}

export function ProductDetailsSummary({ response }: ProductDetailsSummaryProps) {
  const tenantContext = useContext(TenantConfigContext);
  const { tab } = useParams();

  if (!response) {
    return <MetricsLoadingSpinner />;
  }

  const articles = response.sets?.articles ?? [];

  const attributes = response.attributes ?? {};
  const imageUrl = articles.find(article => article.attributes?.artImageUrl != null)?.attributes?.artImageUrl ?? '';
  const productName = attributes.prdName ?? '';
  const uniqueStyleColours = [...new Set(articles.map(a => a.attributes?.styBrandColor))];

  const uniqueSizes = [...new Set(articles.map(a => a.attributes?.artSize))];

  return (
    <EntityHeader
      imageElement={
        <img
          src={buildApiImageUrl(tenantContext.accountNumber, imageUrl)}
          alt={productName}
          onError={addImageNotAvailable}
          className="w-full h-full !bg-snow-50"
        />
      }
      entity={'product'}
      entityDisplayName={productName}
      boxedAttributes={[
        {
          attributeCode: 'prdCategory',
          attributeValue: attributes.prdCategory,
          link: categoryLink(attributes.prdCategory, tab),
        },
        { attributeCode: 'prdNumber', attributeValue: attributes.prdNumber, useRaw: true },
        { attributeCode: 'prdSeason', attributeValue: attributes.prdSeason },
        { attributeCode: 'prdGender', attributeValue: attributes.prdGender },
        { attributeCode: 'prdTargetAge', attributeValue: attributes.prdTargetAge },
      ]}
      rowAttributes={[
        {
          attributeCode: 'styBrandColor',
          labelId: 'entities.name.plural.style',
          attributeValues: uniqueStyleColours,
        },
        {
          attributeCode: 'artSize',
          labelId: 'entities.attribute.name.plural.size',
          attributeValues: uniqueSizes,
        },
      ]}
    />
  );
}
